import { Link } from "react-router-dom"
import DashboardSideBar from "../../components/dashboardSidebar"
import Footer from "../../components/footer"
import Header from "../../components/header"
import SideBar from "../../components/sidebar"
import services from "../../services"
import { useEffect, useState } from "react"
import moment from 'moment'
import constant from "../../constant"
import useIsMobile from "../../hooks/useIsMobile";
import MobileFooter from "../../components/MobileFooter";
import MobileHeader from "../../components/MobileHeader";
const MyCars = () =>{
    const isMobileView = useIsMobile()
    const [carsList,setCarsList] = useState()
    // Partners can add up to 2 cars; Cars53 support adds more from admin
    const MAX_CARS = 2
    const canAddCar = !carsList || carsList.length < MAX_CARS
    const getMyCarHandler = async() =>{
        try {
            const response = await services.Cars.GET_VENDOR_CAR();
            setCarsList(response.data)
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(()=>{
        getMyCarHandler()
    },[])
    if (isMobileView) {
        return (
            <>
                <SideBar />
                <main className="mlux">
                    <MobileHeader right={<Link to="/" className="mlux-avatar"><i className="fas fa-gauge-high"></i></Link>} />
                    <div className="mlux-greet" style={{ margin: '8px 4px 2px' }} data-rise="1">
                        <div className="kick">Your fleet</div>
                        <div className="nm" style={{ fontSize: 24 }}>My Cars</div>
                    </div>

                    {carsList && carsList.length ? carsList.map((item, i) => {
                        const photo = item.photos?.[0] || item.Car?.photos?.[0];
                        return (
                            <div className="mlux-card mlux-car" key={i} data-rise="2">
                                <div className="ph" style={{ height: 160 }}>
                                    {photo ? <img src={constant.IMAGE_URL + photo} crossOrigin="anonymous" alt={`${item.Car?.name}`} />
                                        : <div style={{ height: '100%', display: 'grid', placeItems: 'center', color: '#94a3b8', fontSize: 42 }}><i className="fas fa-car-side"></i></div>}
                                    <div className="ptag" style={{ background: item.isActive ? 'rgba(22,163,74,0.92)' : 'rgba(239,68,68,0.9)', fontSize: 11 }}>{item.isActive ? 'Active' : 'Inactive'}</div>
                                </div>
                                <div className="bd">
                                    <div className="nmrow">
                                        <div>
                                            <div className="nm">{item.Car?.name} {item.Car?.brand}</div>
                                            <div className="perkm">₹{item.perKmCharge}/km · {item.isAcAvailable ? 'AC' : 'Non-AC'} · {item.year}</div>
                                        </div>
                                    </div>
                                    <div className="perkm" style={{ marginTop: 6 }}>RC: {item.rcNumber}</div>
                                    <div className="mlux-rowbtns">
                                        <Link to={`/car/${item.id}`}><i className="far fa-eye"></i> View</Link>
                                        <Link to={`/car/edit/${item.id}`}><i className="far fa-pen"></i> Edit</Link>
                                    </div>
                                </div>
                            </div>
                        );
                    }) : (
                        <div className="mlux-card mlux-empty" data-rise="2">
                            <div className="ic"><i className="fas fa-car-side"></i></div>
                            <h4>No cars added</h4>
                            <p>Add your first cab to start receiving bookings.</p>
                            <Link to="/addcar" className="mlux-btn ghost" style={{ textDecoration: 'none' }}><i className="fas fa-plus"></i> Add a car</Link>
                        </div>
                    )}
                    {!canAddCar && (
                        <p style={{ textAlign: 'center', fontSize: 12.5, color: 'var(--muted)', fontWeight: 600, margin: '14px 8px 0' }}>
                            You can add up to {MAX_CARS} cars. Contact Cars53 support to add more.
                        </p>
                    )}
                </main>
                {canAddCar && <Link to="/addcar" className="mlux-fab"><i className="fas fa-plus"></i></Link>}
                <MobileFooter />
            </>
        );
    }

    return (<>
    <Header/>
    <SideBar/>
        <main class="main">

       


        <div class="user-profile py-5">
            <div class="container">
                <div class="row">
                   <DashboardSideBar/>
                    <div class="col-lg-9">
                        <div class="user-profile-wrapper">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="user-profile-card">
                                        <div class="user-profile-card-header">
                                            <h4 class="user-profile-card-title">My Cars</h4>
                                            <div class="user-profile-card-header-right">
                                                <div class="user-profile-search">
                                                    <div class="form-group">
                                                        <input type="text" class="form-control" placeholder="Search..."/>
                                                        <i class="far fa-search"></i>
                                                    </div>
                                                </div>
                                                {canAddCar
                                                    ? <Link to={'/addcar'} class="theme-btn"><i class="far fa-plus"></i> Add car</Link>
                                                    : <small className="text-muted">Up to {MAX_CARS} cars. Contact Cars53 support to add more.</small>}
                                            </div>
                                        </div>
                                        <div class="table-responsive">
                                            <table class="table text-nowrap">
                                                <thead>
                                                    <tr>
                                                        <th>Cab Info</th>
                                                        <th>Cab Model</th>
                                                        <th>Cab RC</th>
                                                        {/* <th>Driver Assigned</th> */}
                                                        <th>Created Date</th>
                                                        <th>Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {carsList && carsList.length ? carsList.map((item, indx)=>{return(
                                                    <tr key={indx}>
                                                        <td>
                                                            <div class="table-list-info">
                                                                <a href="#">
                                                                   
                                                                    <div class="table-list-content">
                                                                        <h6>{item.Car.name} {item.Car.brand}</h6>
                                                                        <span>Rs.  {item.perKmCharge}</span> <span>AC : {item.isAcAvailable ? 'Yes' : 'No'}</span>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </td>
                                                        <td>
                                                        {item.year}
                                                        </td>
                                                        <td>
                                                        {item.rcNumber}
                                                        </td>
                                                        {/* <td>
                                                        <div class="table-list-info">
                                                                <a href="#">
                                                                
                                                                    <div class="table-list-content">
                                                                        <h6>{item.DriverCar?.User?.firstName || 'NA'} {item.DriverCar?.User?.lastName || ''}</h6>
                                                                       
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </td> */}
                                                        <td>
                                                            <span>{moment(item.createdAt).format('DD-MM-YYYY,hh:mm')}</span>
                                                        </td>
                                                       
                                                        <td><span class={`badge badge-success`}>{item.isActive ? 'Active' : 'Inactive'}</span></td>
                                                        <td>
                                                            <Link to={`/car/${item.id}`}
                                                                class="btn btn-outline-secondary btn-sm rounded-2"
                                                                data-bs-toggle="tooltip" title="Details"><i
                                                                    class="far fa-eye"></i></Link>
                                                                    <Link to={`/car/edit/${item.id}`}
                                                                class="btn ms-2 btn-outline-secondary btn-sm rounded-2"
                                                                data-bs-toggle="tooltip" title="Details"><i
                                                                    class="far fa-pencil"></i></Link>
                                                        </td>
                                                    </tr>
                                                    )}) : null
                                                    }
                                                   
                                                </tbody>
                                            </table>
                                        </div>

                                        <div class="pagination-area d-none">
                                            <div aria-label="Page navigation example">
                                                <ul class="pagination my-3">
                                                    <li class="page-item">
                                                        <a class="page-link" href="#" aria-label="Previous">
                                                            <span aria-hidden="true"><i
                                                                    class="far fa-angle-double-left"></i></span>
                                                        </a>
                                                    </li>
                                                    <li class="page-item active"><a class="page-link" href="#">1</a>
                                                    </li>
                                                    <li class="page-item"><a class="page-link" href="#">2</a></li>
                                                    <li class="page-item"><a class="page-link" href="#">3</a></li>
                                                    <li class="page-item">
                                                        <a class="page-link" href="#" aria-label="Next">
                                                            <span aria-hidden="true"><i
                                                                    class="far fa-angle-double-right"></i></span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </main>
    <Footer/>
    </>
    )
}
export default MyCars